/* oph-bespoke.js — bespoke/offert-landningssida */
(function () {
  var hero = document.querySelector('[data-oph-lp-hero]');

  /* ===== HERO-bildspel ===== */
  if (hero) {
    var track = hero.querySelector('[data-oph-lp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var prev = hero.querySelector('[data-oph-lp-prev]');
    var next = hero.querySelector('[data-oph-lp-next]');
    var i = 0;
    function isMobile() { return window.innerWidth <= 749; }
    function perView() { return isMobile() ? 1 : 2; }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function show(n) {
      if (!track || !slides.length || isMobile()) return;
      i = Math.min(Math.max(n, 0), maxIndex());
      track.style.transform = 'translateX(-' + slides[i].offsetLeft + 'px)';
      if (prev) prev.classList.toggle('is-disabled', i <= 0);
      if (next) next.classList.toggle('is-disabled', i >= maxIndex());
    }
    function syncMobileArrows() {
      if (!isMobile() || !track) return;
      if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
    }
    if (prev) prev.addEventListener('click', function () { if (isMobile()) track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); else show(i - 1); });
    if (next) next.addEventListener('click', function () { if (isMobile()) track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); else show(i + 1); });
    if (track) track.addEventListener('scroll', syncMobileArrows, { passive: true });
    function heroSync() {
      var needsNav = slides.length > perView();
      if (prev) prev.hidden = !needsNav;
      if (next) next.hidden = !needsNav;
      if (isMobile()) { track.style.transform = ''; syncMobileArrows(); } else { show(i); }
    }
    window.addEventListener('resize', heroSync);
    heroSync();
  }

  /* ===== Läs mer / Läs mindre (hero-intro) ===== */
  var rm = document.querySelector('[data-bsp-collapse]');
  if (rm) {
    var rmText = rm.querySelector('[data-bsp-collapse-text]');
    var rmBtn = rm.querySelector('[data-bsp-collapse-toggle]');
    if (rmText && rmBtn) {
      rmText.classList.add('is-clamped');
      var checkClamp = function () {
        var overflowing = rmText.scrollHeight > rmText.clientHeight + 2;
        rmBtn.classList.toggle('is-visible', overflowing || rmText.classList.contains('is-open'));
      };
      rmBtn.addEventListener('click', function () {
        var open = rmText.classList.toggle('is-open');
        rmText.classList.toggle('is-clamped', !open);
        rmBtn.textContent = open ? 'Läs mindre' : 'Läs mer';
      });
      checkClamp();
      window.addEventListener('resize', checkClamp);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamp);
    }
  }

  /* ===== Detalj-slider ===== */
  var dTrack = document.querySelector('[data-oph-lp-detail-track]');
  if (dTrack) {
    var dSlides = dTrack.children;
    var dDots = document.querySelectorAll('[data-oph-lp-dot]');
    var d = 0;
    function dShow(n) {
      d = (n + dSlides.length) % dSlides.length;
      dTrack.style.transform = 'translateX(-' + (d * 100) + '%)';
      dDots.forEach(function (dot, idx) { dot.classList.toggle('is-active', idx === d); });
    }
    dDots.forEach(function (dot) { dot.addEventListener('click', function () { dShow(parseInt(dot.getAttribute('data-oph-lp-dot'), 10)); }); });
    var dPrev = document.querySelector('[data-oph-lp-detail-prev]');
    var dNext = document.querySelector('[data-oph-lp-detail-next]');
    if (dPrev) dPrev.addEventListener('click', function () { dShow(d - 1); });
    if (dNext) dNext.addEventListener('click', function () { dShow(d + 1); });
  }

  /* ===== Miljöbilder ===== */
  var edClip = document.querySelector('[data-oph-lp-editorial]');
  if (edClip) {
    var edTrack = edClip.querySelector('.oph-lp__editorial-track');
    var edItems = Array.prototype.slice.call(edClip.querySelectorAll('.oph-lp__editorial-item'));
    var edDotsWrap = document.querySelector('[data-oph-lp-editorial-dots]');
    var edDots = [];
    var edIndex = 0;
    function edPerView() {
      if (!edItems.length) return 1;
      var itemW = edItems[0].getBoundingClientRect().width || 1;
      return Math.max(1, Math.round(edClip.clientWidth / itemW));
    }
    function edMaxIndex() { return Math.max(0, edItems.length - edPerView()); }
    function edGoTo(n, animate) {
      edIndex = Math.min(Math.max(n, 0), edMaxIndex());
      edTrack.classList.toggle('is-dragging', !animate);
      edTrack.style.transform = 'translateX(-' + edItems[edIndex].offsetLeft + 'px)';
      for (var m = 0; m < edDots.length; m++) { edDots[m].classList.toggle('is-active', m === edIndex); }
    }
    function edBuildDots() {
      var pages = edMaxIndex() + 1;
      if (!edDotsWrap || pages < 2) { if (edDotsWrap) edDotsWrap.innerHTML = ''; edDots = []; edGoTo(0, false); return; }
      edDotsWrap.innerHTML = ''; edDots = [];
      for (var k = 0; k < pages; k++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'oph-lp__editorial-dot'; b.setAttribute('aria-label', 'Sida ' + (k + 1));
        (function (idx) { b.addEventListener('click', function () { edGoTo(idx, true); }); })(k);
        edDotsWrap.appendChild(b); edDots.push(b);
      }
      edGoTo(Math.min(edIndex, edMaxIndex()), false);
    }
    window.addEventListener('resize', edBuildDots);
    edBuildDots();
    var edDown = false, edStartX = 0, edBaseOffset = 0, edMoved = 0;
    edClip.addEventListener('pointerdown', function (e) { edDown = true; edMoved = 0; edStartX = e.clientX; edBaseOffset = edItems[edIndex].offsetLeft; edTrack.classList.add('is-dragging'); edClip.classList.add('is-grabbing'); });
    window.addEventListener('pointermove', function (e) { if (!edDown) return; edMoved = e.clientX - edStartX; edTrack.style.transform = 'translateX(-' + (edBaseOffset - edMoved) + 'px)'; });
    window.addEventListener('pointerup', function () { if (!edDown) return; edDown = false; edClip.classList.remove('is-grabbing'); var threshold = edClip.clientWidth * 0.12; if (edMoved <= -threshold) edGoTo(edIndex + 1, true); else if (edMoved >= threshold) edGoTo(edIndex - 1, true); else edGoTo(edIndex, true); });
  }

  /* ===== Liknande designs ===== */
  var relTrack = document.querySelector('[data-oph-lp-related]');
  if (relTrack) {
    var rCards = Array.prototype.slice.call(relTrack.children);
    for (var r = rCards.length - 1; r > 0; r--) { var rj = Math.floor(Math.random() * (r + 1)); relTrack.appendChild(rCards[rj]); rCards.splice(rj, 1); }
    var rWrap = relTrack.closest('.oph-lp__related-wrap');
    var rSlides = relTrack.children;
    var ri = 0;
    var rPrev = document.querySelector('[data-oph-lp-related-prev]');
    var rNext = document.querySelector('[data-oph-lp-related-next]');
    function rPerView() { if (window.innerWidth <= 749) return 2; if (window.innerWidth <= 1024) return 3; return 4; }
    function rShow(n) {
      if (!rSlides.length || window.innerWidth <= 767) return;
      var max = Math.max(0, rSlides.length - rPerView());
      ri = Math.min(Math.max(n, 0), max);
      relTrack.style.transform = 'translateX(-' + rSlides[ri].offsetLeft + 'px)';
      if (rPrev) rPrev.classList.toggle('is-disabled', ri <= 0);
      if (rNext) rNext.classList.toggle('is-disabled', ri >= max);
    }
    function rArrowTop() { var img = relTrack.querySelector('img'); if (img && img.offsetHeight && rWrap) { rWrap.style.setProperty('--oph-arrow-top', (img.offsetHeight / 2) + 'px'); } }
    function rSync() {
      var mobile = window.innerWidth <= 767;
      var few = rSlides.length <= rPerView();
      if (rPrev) rPrev.hidden = mobile || few;
      if (rNext) rNext.hidden = mobile || few;
      if (mobile) { relTrack.style.transform = ''; ri = 0; } else { rArrowTop(); rShow(ri); }
    }
    if (rPrev) rPrev.addEventListener('click', function () { rShow(ri - 1); });
    if (rNext) rNext.addEventListener('click', function () { rShow(ri + 1); });
    window.addEventListener('resize', rSync);
    var firstImg = relTrack.querySelector('img');
    if (firstImg && !firstImg.complete) firstImg.addEventListener('load', rArrowTop);
    if (window.ResizeObserver && firstImg) new ResizeObserver(rArrowTop).observe(firstImg);
    var rClip = relTrack.closest('.oph-lp__related-clip');
    var rBar = document.querySelector('[data-oph-lp-scrollbar]');
    var rBarTrack = document.querySelector('[data-oph-lp-scrollbar-track]');
    if (rClip && rBar && rBarTrack) {
      var barTrackWidth = function () { var tw = rClip.clientWidth / rClip.scrollWidth * 100; tw = tw < 5 ? 5 : tw; rBar.style.setProperty('--track-width', tw + '%'); rBar.classList.toggle('is-hidden', Math.ceil(tw) >= 100); };
      var barPosition = function () { var pos = Math.abs(rClip.scrollLeft) / (rClip.scrollWidth - rClip.clientWidth); pos *= rBar.clientWidth - rBarTrack.clientWidth; pos = pos < 0 || isNaN(pos) ? 0 : pos; rBar.style.setProperty('--position', Math.round(pos) + 'px'); };
      var barSync = function () { barTrackWidth(); barPosition(); };
      rClip.addEventListener('scroll', barPosition, { passive: true });
      window.addEventListener('resize', barSync);
      setTimeout(barSync, 100);
    }
    rSync();
  }

  /* ===== Begär offert – pop-up ===== */
  var overlay = document.querySelector('[data-quote-overlay]');
  if (overlay) {
    var triggers = document.querySelectorAll('[data-quote-open]');
    var closeEls = overlay.querySelectorAll('[data-quote-close]');
    var qForm = overlay.querySelector('[data-quote-form]');
    var qHp = overlay.querySelector('[data-quote-hp]');
    var qTextarea = overlay.querySelector('[data-quote-textarea]');
    var qCounter = overlay.querySelector('[data-quote-count]');
    var viewForm = overlay.querySelector('[data-quote-view="form"]');
    var viewSuccess = overlay.querySelector('[data-quote-view="success"]');
    var lastFocus = null, closeTimer = null;
    function lockScroll(on) { document.documentElement.classList.toggle('oph-quote-lock', on); document.body.classList.toggle('oph-quote-lock', on); }
    function openModal() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      lastFocus = document.activeElement;
      overlay.hidden = false;
      lockScroll(true);
      requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('is-open'); }); });
      var firstField = overlay.querySelector('input[type="email"]');
      if (firstField && viewSuccess.hidden) { setTimeout(function () { firstField.focus(); }, 320); }
    }
    function closeModal() {
      overlay.classList.remove('is-open');
      lockScroll(false);
      closeTimer = setTimeout(function () { overlay.hidden = true; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showSuccess() {
      viewForm.hidden = true;
      viewSuccess.hidden = false;
      viewSuccess.classList.remove('is-playing');
      void viewSuccess.offsetWidth;
      viewSuccess.classList.add('is-playing');
    }
    Array.prototype.forEach.call(triggers, function (t) { t.addEventListener('click', openModal); });
    Array.prototype.forEach.call(closeEls, function (el) { el.addEventListener('click', closeModal); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });
    if (qTextarea && qCounter) { var qsync = function () { qCounter.textContent = String(qTextarea.value.length); }; qTextarea.addEventListener('input', qsync); qsync(); }
    if (qForm) { qForm.addEventListener('submit', function (e) { if (qHp && qHp.value.trim() !== '') { e.preventDefault(); return false; } }); }
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') === 'true') { showSuccess(); openModal(); setTimeout(function () { viewSuccess.classList.add('is-playing'); }, 60); }
    } catch (err) {}
  }
})();
